import 'isomorphic-fetch';
import queryString from 'query-string';
import config from '../utils/config';

const prismicMiddleware = () => (next) => (action) => {
  if (!action.prismic) return next(action);

  next({ type: `${action.type}_REQUEST` });

  return fetch(`https://${config.prismicHost}/api/v2`)
    .then((response) => {
      if (!response.ok) {
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject({
          data: { message: response.statusText },
          status: response.status,
        });
      }

      return response.json().then((data) => data.refs[0].ref);
    })
    .then((apiRef) => {
      const query = queryString.stringify({
        ref: apiRef,
        q: `[[at(my.${action.prismic.type}.uid, "${action.prismic.uid}")]]`,
      });
      return fetch(`https://${config.prismicHost}/api/v2/documents/search?${query}`)
        .then((response) => {
          if (!response.ok) {
            // eslint-disable-next-line prefer-promise-reject-errors
            return Promise.reject({
              data: { message: response.statusText },
              status: response.status,
            });
          }

          return response.json().then((data) => data && data.results && data.results[0]);
        })
        .catch((err) => Promise.reject(err));
    })
    .then((result) => {
      if (typeof result !== 'undefined') {
        return {
          type: `${action.type}_SUCCESS`,
          payload: result,
        };
      }
      return {
        type: `${action.type}_FAILURE`,
        error: {
          status: 404,
        },
      };
    })
    .catch((err) => ({
      type: `${action.type}_FAILURE`,
      payload: { error: err },
    }))
    .then(next);
};

export default prismicMiddleware;
